import React, { useEffect } from "react";
import MaterialTable from "material-table";
import { tableIcons } from "../../shared/TableIcons";
import CircularProgress from "@material-ui/core/CircularProgress";
import exportPDF from "../../services/exportPDF";
import exportCSV from "../../services/exportCSV";
const AverageTimesPerUser = (props) => {
  const { data } = props;
  return (
    <div>
      {data !== "" && data !== [] ? (
        <MaterialTable
          icons={tableIcons}
          title="Μέσος χρόνος απόκρισης Ανά Χειριστή"
          columns={[
            {
              title: "Κατάσταση",
              field: "status",
            },
            {
              title: "Μέσος χρόνος ανάθεσης (Λεπτά)",
              field: "acknowlegedTime",
            },
            {
              title: "Μέσος χρόνος κλεισίματος (Λεπτά)",
              field: "closureTime",
            },
            {
              title: "Χειριστής",
              field: "userEmail",
              defaultGroupOrder: 0,
            },
          ]}
          data={data}
          localization={{
            body: {
              emptyDataSourceMessage: "Δεν υπάρχουν Εγγραφές",
            },
            toolbar: {
              addRemoveColumns: "Προσθέστε ή αφαιρέστε κολώνες",
              showColumnsTitle: "Δείξτε κολώνες",
              addTooltip: "Προσθήκη",
              searchTooltip: "Αναζήτηση",
              searchPlaceholder: "Αναζήτηση",
              exportTitle: "Εξαγωγή",
              exportCSVName: "Εξαγωγή σε CSV",
              exportPDFName: "Εξαγωγή σε PDF",
            },
            grouping: {
              placeholder: "Σύρετε για να ομαδοποιήσετε",
              groupedBy: "Σύρετε για να ομαδοποιήσετε",
            },
            pagination: {
              firstTooltip: "Πρώτη Σελίδα",
              lastTooltip: "Τελευταία Σελίδα",
              previousTooltip: "Προηγούμενη Σελίδα",
              nextTooltip: "Επόμενη Σελίδα",
              labelDisplayedRows: "{from}-{to} από {count}",
              labelRowsSelect: "Εγγραφές ανά Σελίδα",
            },
            header: {
              actions: "Ενέργειες",
            },
          }}
          options={{
            searchFieldAlignment: "left",
            exportPdf: (columns, data) => {
              exportPDF(columns, data);
            },
            exportCsv: (columns, data) => {
              exportCSV(columns, data);
            },
            columnsButton: true,
            exportButton: true,
            grouping: true,
            sorting: false,
            filtering: false,
            exportAllData: true,
          }}
        />
      ) : (
        <CircularProgress></CircularProgress>
      )}
    </div>
  );
};

export default AverageTimesPerUser;
